import { defineComponent } from 'vue';
import type { ComponentPublicInstance } from 'vue';
import { IEmitConfig } from '@/shared/interfaces';
import { Nullable } from '@/shared/types';

export { getFileLoc } from '@/shared/helpers';

export type TComponentForEmitTo = ComponentPublicInstance;

export const emitTo = <T extends unknown = any>(component: TComponentForEmitTo, data: T, emitConfig: Nullable<IEmitConfig>) => {
  const parentComponent = emitConfig?.emitToComponent || component.emitConfig?.emitToComponent;
  const eventName = emitConfig?.eventName || component.emitConfig?.eventName;

  let emitterComponent = component;
  while (emitterComponent.$parent && emitterComponent.$parent.$options.name !== parentComponent) {
    emitterComponent = emitterComponent.$parent;
  }

  if (component.$parent && eventName) {
    component.$emit(eventName, data);
  } else {
    /* eslint-disable-next-line */
    console.warn(`WARNING: emitTo() couldn't find parent component name '${parentComponent}' @ '${component.$options.name}'`);
  }
};

// Anything you add to this mixin, add as a property to IRentsyncVueInstance to maintain type safety.
export default defineComponent({
  props: {
    eventConfig: {
      type: Object as () => IEmitConfig,
      default() { return null; },
    },

    isCreatePermitted: {
      type: Boolean,
      default: true,
    },

    isUpdatePermitted: {
      type: Boolean,
      default: true,
    },

    isDeletePermitted: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    emitConfig(): IEmitConfig {
      const emitToComponent = this.$parent ? this.$parent.$options.name : '';
      const eventName = `${this.$options.name}-activated`;
      return { emitToComponent, eventName, ...(this.eventConfig || {}) } as IEmitConfig;
    },
  },
  methods: {

    emitTo(data?: any, emitConfig?: IEmitConfig) {
      const parentComponent = emitConfig?.emitToComponent || this.emitConfig.emitToComponent;
      const eventName = emitConfig?.eventName || this.emitConfig.eventName;

      let component: any = this;
      while (component.$parent && component.$parent.$options.name !== parentComponent) {
        component = component.$parent;
      }

      if (component.$parent) {
        component.$emit(eventName, data);
      } else {
        /* eslint-disable-next-line */
        console.log(`WARNING: emitTo() couldn't find parent component name '${parentComponent}' @ '${this.$options.name}'`);
      }
    },
  },
});
